import { createFileRoute, redirect } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import { workspaceInvitationsQueries } from "@/api/resources/workspaceInvitations/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import OnboardingPage from "@/components/Onboarding/OnboardingPage";

export const Route = createFileRoute("/_auth/welcome")({
  loader: async ({ context }) => {
    const claims = await context.queryClient.ensureQueryData(authQueries.getAuthClaims());
    if (!claims) {
      throw redirect({
        to: "/login",
      });
    }

    const profile = await context.queryClient.ensureQueryData(authQueries.getAuthUserProfile(claims.sub));
    if (!profile) {
      throw redirect({
        to: "/login",
      });
    }

    await context.queryClient.ensureQueryData(workspacesQueries.listAll());
    await context.queryClient.ensureQueryData(workspaceInvitationsQueries.listInvited(profile.email));
  },
  component: OnboardingPage,
});
